import { Helmet } from 'react-helmet';
import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShortFilterData from './ShortFilterData';
import useLadyService from '@/services/LadyService';
import {
	hideShort,
	show,
	showShortFilter,
} from '@/stores/slices/showFilterSlice';
import './shortFilter.scss';
import FilterData from '../filter/FilterData';
import { getDisabledFilters } from '@/stores/slices/filterSlice';
import {
	Select,
	Button,
	Icon,
	InputNick,
	Checkbox,
	SelectCountry,
} from '@/components/ui';
import { useFilterLogicContext } from '../filter/FilterLogicProvider';
import { useNavigate, useParams } from 'react-router-dom';
import {
	getCountriesData,
	getUserCurrentCity,
} from '@/stores/slices/userSlice';

const ShortFilter = () => {
	const { t } = useLadyService();
	const dispatch = useDispatch();
	const shortFilterOpen = useSelector(showShortFilter);
	const filterData = FilterData();
	const disabled_filters = useSelector(getDisabledFilters);
	const FILTER = useFilterLogicContext();
	const params = useParams();
	const countriesData = useSelector(getCountriesData);
	const currentCity = useSelector(getUserCurrentCity);

	const [currentActive, setCurrentActive] = useState('');

	const disabled = useMemo(() => {
		return new Set(disabled_filters);
	}, [disabled_filters]);

	const [selected_gender, setSelectedGender] = useState('all');

	const other_options = useMemo(() => {
		return {
			gender: [
				{
					id: 1000,
					title: t('all'),
					value: 'all',
				},

				{
					id: 67,
					title: t('girls'),
					value: 'female',
					disabled: disabled?.has('genderFemale'),
					icon: 'gender-female',
				},

				{
					id: 68,
					title: t('guys'),
					value: 'male',
					disabled: disabled?.has('genderMale'),
					icon: 'gender-male',
				},

				{
					id: 66,
					title: t('trans'),
					value: 'trans',

					disabled: disabled?.has('genderTrans'),

					icon: 'gender-trans',
				},

				{
					id: 69,
					title: t('couples'),
					value: 'couple',
					disabled: disabled?.has('genderCouple'),
					icon: 'gender-couple',
				},
			].sort((a, b) => {
				if (a.value === selected_gender) {
					return -1;
				}
				if (b.value === selected_gender) {
					return 1;
				}
				return 0;
			}),
		};
	}, [disabled, t, selected_gender]);

	const setGender = async (value) => {
		console.log(`=> trigger set gender: `);
		const found = other_options.gender.find((i) => i.value === value);

		const obj = {
			value: value,
			title: found ? (value === 'all' ? t('pol') : found.title) : '-',
			icon: found ? found.icon : '-',
		};

		setSelectedGender(obj);

		if (value !== 'all') {
			FILTER.handleInstantRadio({ gender: [value] });
		} else {
			FILTER.handleInstantRadio({ gender: [] });
		}

		dispatch(hideShort());

		localStorage.setItem('save_gender_filter', value);
	};

	useEffect(() => {
		const savedGender = localStorage.getItem('save_gender_filter');
		if (FILTER.filterState.gender.length === 1 && other_options.gender) {
			const transformed = FILTER.filterState.gender.map((i) =>
				FILTER.getFilterValue(i, true) === 'couples'
					? 'couple'
					: FILTER.getFilterValue(i, true),
			);

			const found = other_options.gender.find(
				(i) => i.value === transformed[0],
			);

			const obj = {
				value: transformed[0],
				title: found
					? transformed[0] === 'all'
						? t('pol')
						: found.title
					: '-',
				icon: found ? found.icon : '-',
			};

			setSelectedGender(obj);
		} else if (other_options.gender) {
			if (savedGender && !params.params) {
				const found = other_options.gender.find(
					(i) => i.value === savedGender && i.value !== 'all',
				);
				if (found) {
					setGender(found.value);
				} else {
					setSelectedGender({
						...other_options.gender[0],
						title: t('pol'),
					});
				}
			} else {
				setSelectedGender({
					...other_options.gender[0],
					title: t('pol'),
				});
			}
		}
	}, [FILTER.filterStateIndicator]);

	const priceRef = useRef(null);
	const ageRef = useRef(null);

	useEffect(() => {
		const age = FILTER.filterState.ranges.current_state.age;
		const price = FILTER.filterState.ranges.current_state.price;
		if (
			priceRef.current &&
			typeof priceRef.current.setValues === 'function' &&
			ageRef.current &&
			typeof ageRef.current.setValues === 'function'
		) {
			priceRef.current.setValues(price.min, price.max);
			ageRef.current.setValues(age.min, age.max);
		}
	}, [FILTER.filterStateIndicator]);

	return (
		<>
			{!!shortFilterOpen ? (
				<Helmet>
					<html className={'lock'}></html>
				</Helmet>
			) : null}
			<form
				className={`short-filter${shortFilterOpen ? ' _active' : ''}`}
			>
				{/* genders selector */}
				<div className="short-top-selects">
					<Select
						name={'gender_select'}
						onChange={setGender}
						options={other_options.gender}
						arrowSize={'m'}
						withoutTitle={true}
						withIcon={true}
						clazzWrapper={'select-field'}
						controlledValue={selected_gender.value}
						controlledTitle={selected_gender.title}
						controlledIcon={selected_gender.icon}
						clazzSvg={'color-green'}
					/>

					<SelectCountry
						data={countriesData}
						name={'city-create-filter'}
						clazz={`button button-xs select-city`}
						arrowSize={'m'}
						type={'flag'}
						defaultTitle={currentCity.title}
						currentActiveIndex={currentActive}
						isMain={true}
						activeCountry={currentCity.icon}
						setActive={setCurrentActive}
						selectDistrict={true}
					/>
				</div>

				<Button
					onClick={() => dispatch(hideShort())}
					clazz={'button-icon filter__close'}
				>
					<Icon
						size={'l'}
						spritePath={'close'}
					/>
				</Button>

				<div className="short-filter__body">
					<hr className="mt-8" />

					{/* SEARCH HERE */}
					<InputNick
						type="search"
						placeholder={t('modelname')}
						id="headerSearch"
						clazz={'search__input'}
						name={'nickname'}
					/>

					{/* <div className="d-flex justify-sb gap-8 filter--price">
						<InputRange
							ref={priceRef}
							min={
								FILTER.filterState.ranges.default_state.price
									.min
							}
							max={
								FILTER.filterState.ranges.default_state.price
									.max
							}
							step={10}
							clazz={'range--price w-100'}
							inputIdLeft={'minPriceFilter'}
							inputIdRight={'maxPriceFilter'}
							title={`${t('price')},`}
							name={'price'}
							subtitle={`${lang === 'cz' ? ' Kč' : ' €'}/${t(
								'hour',
							)}`}
							price
							warning={true}
							onChange={(e) =>
								FILTER.handleRangeChange('price', e)
							}
						/>

						<InputRange
							ref={ageRef}
							min={
								FILTER.filterState.ranges.default_state.age.min
							}
							max={
								FILTER.filterState.ranges.default_state.age.max
							}
							step={1}
							clazz={'range--age w-100'}
							inputIdLeft={'minAgeFilter'}
							inputIdRight={'maxAgeFilter'}
							title={`${t('age')},`}
							name={'age'}
							subtitle={` ${t('years')}`}
							warning={true}
							onChange={(e) => FILTER.handleRangeChange('age', e)}
						/>
					</div> */}

					<div className="filter__checkbox-buttons">
						{filterData.place
							.filter((i) => i.value !== 'salon')
							.map((i) => {
								return (
									<Checkbox
										key={i.id}
										name={i.name}
										id={i.id}
										value={i.value}
										title={i.title}
										checked={i.checked}
										buttonCheckbox={true}
										count={i.count}
										disabled={i.disabled}
										onChange={(e) => {
											FILTER.handleInstantCheckBox(e);
											dispatch(hideShort());
										}}
									/>
								);
							})}
					</div>

					<div className="short-filter__group">
						{ShortFilterData().options.map((i) => {
							if (!i.isLink)
								return (
									<Checkbox
										linkCheckbox={i.isLink}
										key={i.id}
										name={i.name}
										id={i.id}
										value={i.value}
										title={i.title}
										checked={i.checked}
										count={i.count}
										disabled={i.disabled}
										onChange={(e) => {
											FILTER.handleInstantCheckBox(e);
											dispatch(hideShort());
										}}
									/>
								);
						})}
					</div>

					<div className="buttonsGroup">
						{ShortFilterData().options.map((i) => {
							if (i.isLink)
								return (
									<Checkbox
										linkCheckbox={i.isLink}
										key={i.id}
										name={i.name}
										id={i.id}
										value={i.value}
										title={i.title}
										checked={i.checked}
										count={i.count}
										disabled={i.disabled}
										onChange={(e) => {
											FILTER.handleInstantCheckBox(e);
											dispatch(hideShort());
										}}
									/>
								);
						})}
					</div>

					<Button
						size={'l'}
						clazz={'button--tetriary short-filter__button'}
						onClick={() => dispatch(show())}
					>
						{t('allfilters')}
						<Icon
							size={'l'}
							spritePath={'filter'}
						/>
					</Button>
				</div>
			</form>
		</>
	);
};

export default ShortFilter;
